import { I9Type } from "../components/i9-task/i9-data";
import { I9Response } from "../components/i9-task/i9-controlled";

export enum ScreenResult {
  Complete = "Complete",
  Pending = "Pending",
  Error = "Error",
  Completed = "Completed",
  Undefined = "Undefined",
}

export const TRANSLATED_SCREEN_RESULT: Record<string, string> = {
  Complete: "checklist-General-ASH-Status-Complete",
  Pending: "checklist-General-TaskStatus-Pending", //not added
  Error: "checklist-General-TaskStatus-Error",
};

export const CAAS_STATUS_TO_I9_STATUS: Record<string, string> = {
  Initiated: ScreenResult.Pending,
  WaitingForASHToCreateOrder: ScreenResult.Pending,
  PendingSection1: ScreenResult.Pending,
  Section1Complete: ScreenResult.Pending,
  Section2Complete: ScreenResult.Complete,
  PendingSection3: ScreenResult.Pending,
  Section3Complete: ScreenResult.Complete,
  "Remote+PendingSection1": ScreenResult.Pending,
  "Remote+Section1Complete": ScreenResult.Pending,
  "Remote+PendingSection3": ScreenResult.Complete,
  Archived: ScreenResult.Pending,
  Error: ScreenResult.Error,
};

export const getI9Status = (i9Response: I9Response): string => {
  const i9Type = i9Response.isRemote === true ? I9Type.Remote : I9Type.Normal;
  if (!i9Response.status) {
    return ScreenResult.Error;
  }
  const specificKey = `${i9Type}+${i9Response.status}`;
  const commonKey = i9Response.status;
  return (
    CAAS_STATUS_TO_I9_STATUS[specificKey] || CAAS_STATUS_TO_I9_STATUS[commonKey]
  );
};

export const getBgcStatus = (status: string): string => {
  if (status === ScreenResult.Completed) {
    return ScreenResult.Complete;
  } else {
    return ScreenResult.Pending;
  }
};

export const getDtStatus = (status: string): string => {
  if (status === ScreenResult.Completed) {
    return ScreenResult.Complete;
  } else {
    return ScreenResult.Pending;
  }
};
